var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-list",on:{"click":function($event){$event.stopPropagation();}}},[(_vm.longParams.channelId === _vm.healthChannelId && _vm.union !== _vm.noHeadUnion)?_c('HealthNav'):_vm._e(),_vm._v(" "),(
      _vm.catList.length > 0 &&
      !['3', _vm.healthChannelId].includes(_vm.longParams.channelId)
    )?_c('div',[(_vm.longParams.channelId != 998)?_c('NavIndex',{attrs:{"catList":_vm.catList,"onChange":_vm.onCateNavChange}}):_vm._e(),_vm._v(" "),(_vm.longParams.channelId == 998)?_c('BookNavIndex',{attrs:{"catList":_vm.catList,"onChange":_vm.onBookNavChange}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.catList.length > 0 && _vm.longParams.channelId !== _vm.healthChannelId)?_c('div',{staticClass:"bread"},[_c('a',{attrs:{"href":_vm.longParams.channelId === '3'
          ? '/shop/birthday'
          : _vm.longParams.channelId === '998' || _vm.longParams.channelId === '18'
          ? '/book'
          : '/shop/home',"target":"_self"}},[_vm._v(_vm._s(_vm.longParams.channelId === "3"
          ? _vm.TLang('生日汇', 'my')
          : _vm.longParams.channelId === "998" || _vm.longParams.channelId === "18"
          ? _vm.TLang('图书', 'my')
          : _vm.TLang('优选生活', 'my')))]),_vm._v(" "),_c('span',[_vm._v(">")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.TLang('商品列表','list')))])]):_vm._e(),_vm._v(" "),(_vm.catList.length > 0)?_c('div',[_c('SelectBar',{attrs:{"hideBrand":_vm.longParams.channelId !== _vm.healthChannelId,"catList":_vm.catList,"brandList":_vm.brandList,"selectType":'list',"onCateChange":_vm.onCateChange,"onBrandChange":(brandname) => {
          _vm.longParams = {
            ..._vm.longParams,
            pageNumber: 1,
            brandName: brandname,
          };
          _vm.addPageNumbberQuery({
            pageNumber:'',
          })
          _vm.init();
        },"chooseAll":_vm.chooseAll,"changeBirthdayFirstType":_vm.changeBirthdayFirstType}})],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
      _vm.longParams.channelId === _vm.healthChannelId
        ? _vm.exts && _vm.exts.includes(5) && Number(_vm.healthgoodsFlag) === 0
          ? false
          : true
        : true
    ),expression:"\n      longParams.channelId === healthChannelId\n        ? exts && exts.includes(5) && Number(healthgoodsFlag) === 0\n          ? false\n          : true\n        : true\n    "}],staticClass:"SearchBar-wrap"},[_c('SearchBar',{attrs:{"onSortFieldChange":(sortField) => {
          _vm.longParams = {
            ..._vm.longParams,
            sortField,
            sortType:'',
            pageNumber: 1
          };
          _vm.addPageNumbberQuery({
            pageNumber:'',
          })
          _vm.init();
        },"onSortTypeChange":(sortType) => {
          _vm.longParams = {
            ..._vm.longParams,
            sortField: 4,
            sortType,
            pageNumber: 1,
          };
          _vm.addPageNumbberQuery({
            pageNumber:'',
          })
          _vm.init();
        },"onPriceChange":(price) => {
          _vm.longParams = {
            ..._vm.longParams,
            ...price,
            pageNumber: 1,
          };
          _vm.addPageNumbberQuery({
            pageNumber:'',
          })
          _vm.init();
        },"onKeyWordChange":(wordsName) => {
          _vm.longParams = {
            ..._vm.longParams,
            wordsName,
            pageNumber: 1,
          };
          _vm.addPageNumbberQuery({
            pageNumber:'',
          })
          _vm.init();
        },"onStockChange":(containsNoStock) => {
          _vm.longParams = {
            ..._vm.longParams,
            containsNoStock,
            pageNumber: 1,
          };
          _vm.addPageNumbberQuery({
            pageNumber:'',
          })
          _vm.init();
        },"total":_vm.total,"noStockGrayStatus":_vm.noStockGrayStatus}})],1),_vm._v(" "),(_vm.longParams.channelId == _vm.healthChannelId)?_c('FixedButton',{attrs:{"hidenQrcode":"","hidenToTop":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"goods-wrap"},[_c('ul',_vm._l((_vm.goodsList),function(goods){return _c('li',{key:goods.goodsId},[_c('Goods',{attrs:{"goods":goods,"onClick":_vm.toDetailAndMemory,"onClickAdd":_vm.onClickAdd.bind(this, goods),"purchaseType":goods.purchaseType}})],1)}),0),_vm._v(" "),(_vm.isEmpty)?_c('Empty',{attrs:{"hideCity":_vm.longParams.channelId !== _vm.healthChannelId,"topre":_vm.topre}}):_vm._e()],1),_vm._v(" "),(_vm.goodsList.length && _vm.total > 20)?_c('div',{staticClass:"Pagination"},[_c('Pagination',{attrs:{"current-page":_vm.longParams.pageNumber * 1,"page-size":20,"layout":"prev, pager, next, total, jumper","total":_vm.total,"background":""},on:{"update:currentPage":function($event){return _vm.$set(_vm.longParams, "pageNumber * 1", $event)},"update:current-page":function($event){return _vm.$set(_vm.longParams, "pageNumber * 1", $event)},"current-change":_vm.handleCurrentChange}})],1):_vm._e(),_vm._v(" "),_c('SkuPicker',{attrs:{"visible":_vm.SkuPickerShow,"goods":_vm.activeGoods,"onClose":_vm.onCloseSkuModal,"onAdd":_vm.onClickSkuAdd}}),_vm._v(" "),_c('FixedButton',{attrs:{"channelName":_vm.longParams.channelId === _vm.healthChannelId ? _vm.TLang('健康商城', 'my') : _vm.TLang('优选生活', 'my')}}),_vm._v(" "),_c('Dialog',{attrs:{"title":" ","visible":_vm.dialogVisible,"width":"420px","custom-class":"product-dialog","center":"","top":"50vh","lock-scroll":false},on:{"update:visible":function($event){_vm.dialogVisible=$event},"open":function($event){_vm.dialogVisible = true}}},[_c('img',{attrs:{"src":require('../../../assets/images/cart_ok.png')}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.TLang('加入购物车成功','my')))]),_vm._v(" "),_c('div',{staticClass:"goods-name"},[_vm._v("\n      "+_vm._s(_vm.chooseOfAdd.goodsName)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"goods-sku-name"},[_vm._v("\n      "+_vm._s(_vm.TLang('规格','my'))+"："+_vm._s(_vm.chooseOfAdd.specValue1 || _vm.chooseOfAdd.specName)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('button',{class:_vm.CookiesOne==='en-US' ?'close-btn close-btn-One':'close-btn',on:{"click":function($event){return _vm.toDetail(_vm.chooseOfAdd)}}},[_vm._v("\n        "+_vm._s(_vm.TLang('查看商品详情','my'))+"\n      ")]),_vm._v(" "),_c('button',{staticClass:"buy-btn primary",on:{"click":_vm.onClickGoBuy}},[_vm._v(_vm._s(_vm.TLang('去结算','my')))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }